
































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import ContactPanel from '@/components/ContactPanel.vue';
import StartNav from '@/components/StartNav.vue';

@Component({
  components: {
    ContactPanel,
    StartNav
  }
})
export default class P0905 extends Vue {
  readonly VUE_APP_EVENTOS_TOP_URL = process.env.VUE_APP_EVENTOS_TOP_URL;

  private signup() {
    this.$auth.loginWithRedirect({ initialDisplay: 'signup' });
  }
}
